export enum ActionType {
	DEFINE_QUESTIONS = "quiz/DEFINE_QUESTIONS",
	CHECK_ANSWER = "quiz/CHECK_ANSWER",
	QUIZ_IS_PASSED = "quiz/QUIZ_IS_PASSED",
	SET_QUIZ_STARTED = "quiz/SET_QUIZ_STARTED",
	SET_SIGN_UP_OPENED = "quiz/SET_SIGN_UP_OPENED",
	UPDATE_CURRENT_SERVICE = "quiz/UPDATE_CURRENT_SERVICE",
	TOGGLE_BUTTON_BACK = "quiz/TOGGLE_BUTTON_BACK",
	TOGGLE_BUTTON_TO_COMMON = "quiz/TOGGLE_BUTTON_TO_COMMON",
	ADD_CALCULATOR_DATA = "quiz/ADD_CALCULATOR_DATA",
	SET_CALL_TIME_FORM_REGIME = "quiz/SET_CALL_TIME_FORM_REGIME",
	ADD_QUIZ_RESULT = "quiz/ADD_QUIZ_RESULT",
	REMOVE_QUIZ_RESULT = "quiz/REMOVE_QUIZ_RESULT",
	TOGGLE_DOCTOR = "quiz/TOGGLE_DOCTOR",
	TOGGLE_LABEL = "quiz/TOGGLE_LABEL",
	TOGGLE_FLYING_BUTTON = "quiz/TOGGLE_FLYING_BUTTON",
	GET_PHONE = "quiz/GET_PHONE",
	SET_QUIZ_PROGRESS = "quiz/SET_QUIZ_PROGRESS",
	TOGGLE_SERVICE_LIST_DROPDOWN_MENU = "quiz/TOGGLE_SERVICE_LIST_DROPDOWN_MENU",
  SET_CONVR_TEST_VARIATIONS = "quiz/SET_CONVR_TEST_VARIATIONS",
	SET_POPUP_WIDTH = "quiz/SET_POPUP_WIDTH",
	DISPLAY_POPUP_WINDOW = "quiz/DISPLAY_POPUP_WINDOW",
	SET_ACTIVE_POPUP_WINDOW_ID = "quiz/SET_ACTIVE_POPUP_WINDOW_ID"
}